'use client';

import { c as _c } from "react/compiler-runtime";
import { memo, Suspense } from 'react';
import PromotionBannerDynamic from 'components/consumer/promotion-banner-dynamic';
import ConsumerHeader from 'components/consumer/consumer-header';
import NewLayoutMenu from './NewLayoutMenu';
import NewSubMenuLayoutMenu from './NewSubMenuLayoutMenu';
const PageHeaderForLayout = t0 => {
  const $ = _c(10);
  const {
    layoutName
  } = t0;
  let t1;
  if ($[0] !== layoutName) {
    t1 = ["Default", "NewLayout", "ConsumerWithoutFooter", "NewSubMenuLayout"].includes(layoutName) && <><Suspense fallback={<div className="min-h-[55px] max-[767px]:min-h-[70px]" />}><PromotionBannerDynamic /></Suspense><Suspense fallback={<div className="bg-white z-[1002] sticky top-0 min-h-[55px] max-[1023px]:min-h-[3.75rem]" />}><ConsumerHeader /></Suspense></>;
    $[0] = layoutName;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== layoutName) {
    t2 = layoutName === "NewLayout" && <Suspense><NewLayoutMenu /></Suspense>;
    $[2] = layoutName;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== layoutName) {
    t3 = layoutName === "NewSubMenuLayout" && <Suspense><NewSubMenuLayoutMenu /></Suspense>;
    $[4] = layoutName;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default memo(PageHeaderForLayout);